import React from 'react';
import PropTypes from 'prop-types';
import styles from './ScanLeadsHealth.module.scss';

const ScanLeadsHealth = ({ progress }) => {
  return (
    <div className="p-20">
      <div className="font13 fw500 color777 pb-25">Let’s have a quick leads health checked</div>
      <div className={`${styles.ScanLeadsHealth} p-20`}>
        <div className={`${styles.ScanLeadsHealth__imagebox}`}>
          <img
            alt="scanning_doc"
            className={`${styles.ScanLeadsHealth__image}`}
            src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/scanning_doc.svg"
          />
          <div className={`${styles.ScanLeadsHealth__image__line} ${styles.up_down}`} />
        </div>
        <div className="font9 fw500 color777 mt-10 text_center">Checking Keywords..</div>
        <div className="font16 fw500 color777 mt-16 text_center" htmlFor="disk_d">
          {progress}%
        </div>
        <div className={`${styles.ScanLeadsHealth__meterbox}`}>
          <meter className={`${styles.ScanLeadsHealth__meter}`} id="disk_d" value={progress / 100} />
        </div>
        <div className="font13 fw500 color777 mt-20">
          Grab a cup of coffee while we run a health check of your contract
        </div>
      </div>
    </div>
  );
};

export default ScanLeadsHealth;

ScanLeadsHealth.propTypes = {
  progress: PropTypes.number,
};
